<audio
  #audioComponent
  controls
  [autoplay]="input.autoplay | parse: context | async"
  [preload]="input.preload"
>
  <source [src]="input.url | parse: context | async" [type]="input.audioType" />
  Your browser does not support the audio element.
</audio>
